/** 品质控制 **/
import Layout from "@/views/layout/Layout";
const qualityControlRouter = {
  path: "/qualityControl",
  component: Layout,
  name: "qualityControl",
  meta: {
    title: "品质控制",
    icon: "qualityControl",
    roles: ["pinzhikongzhi_web"],
  },
  alwaysShow: true,
  children: [
    {
      path: "moduleManagement",
      component: () => import("@/views/qualityControl/moduleManagement/index"),
      name: "模块管理",
      meta: {
        title: "模块管理",
        roles: ["pzkz_mokuaiguanli"],
      },
      children: [
        {
          path: "checkModule",
          component: () =>
            import("@/views/qualityControl/moduleManagement/checkModule"),
          name: "检查模块",
          meta: {
            title: "检查模块",
            roles: ["pzkz_jianchamokuai"],
          },
          children: [],
        },
        {
          path: "questionAskingModule",
          component: () =>
            import(
              "@/views/qualityControl/moduleManagement/questionAskingModule"
            ),
          name: "问题征询模块",
          meta: {
            title: "问题征询模块",
            roles: ["pzkz_wentizhengxunmokuai"],
          },
          children: [],
        },
      ],
    },
    {
      path: "templateManagement",
      component: () =>
        import("@/views/qualityControl/templateManagement/index"),
      name: "模版管理",
      meta: {
        title: "模版管理",
        roles: ["pzkz_mobanguanli"],
      },
      children: [
        {
          path: "checkModule",
          component: () =>
            import("@/views/qualityControl/templateManagement/checkModule"),
          name: "检查模版管理",
          meta: {
            title: "检查模版管理",
            roles: ["pzkz_jianchamobanguanli"],
          },
          children: [],
        },
        {
          path: "questionAskingModule",
          component: () =>
            import(
              "@/views/qualityControl/templateManagement/questionAskingModule"
            ),
          name: "问题征询模版管理",
          meta: {
            title: "问题征询模版管理",
            roles: ["pzkz_wentizhengxunmobanguanli"],
          },
          children: [],
        },
      ],
    },
    {
      path: "problemClassificationManagement",
      component: () =>
        import("@/views/qualityControl/problemClassificationManagement"),
      name: "问题分类管理",
      meta: {
        title: "问题分类管理",
        roles: ["pzkz_pzkz_wentifenleiguanli"],
      },
      children: [],
    },
    {
      path: "qualityControl",
      component: () => import("@/views/qualityControl/qualityControl/index"),
      name: "品质控制",
      meta: {
        title: "品质控制",
        roles: ["pzkz_pinzhikongzhi"],
      },
      children: [
        {
          path: "checkManagement",
          component: () =>
            import(
              "@/views/qualityControl/qualityControl/checkManagement/index"
            ),
          name: "检查管理",
          meta: {
            title: "检查管理",
            roles: ["pzkz_pzkz_jianchaguanli"],
          },
          children: [
            {
              path: "plannedArrangement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/plannedArrangement"
                ),
              name: "任务列表",
              meta: {
                title: "任务列表",
                roles: ["pzkz_pzkz_jc_jihualiebiao"],
              },
              children: [],
            },
            {
              path: "taskExecute",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/taskExecute"
                ),
              name: "任务执行",
              meta: {
                title: "任务执行",
                roles: ["pzkz_pzkz_jc_renwuzhixing"],
              },
              children: [],
            },

            {
              path: "taskSupervision",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/taskSupervision"
                ),
              name: "任务管理",
              meta: {
                title: "任务管理",
                roles: ["pzkz_pzkz_jc_renwujianguan"],
              },
              children: [],
            },
            {
              path: "workItemSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/workItemSetup"
                ),
              name: "整改执行",
              meta: {
                title: "整改执行",
                roles: ["pzkz_pzkz_jc_zhenggaizhixing"],
              },
              children: [],
            },
            {
              path: "workScheduleSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/rectificationSupervision"
                ),
              name: "整改监管",
              meta: {
                title: "整改监管",
                roles: ["pzkz_pzkz_jc_zhenggaijianguan"],
              },
              children: [],
            },
            {
              path: "statisticalStatement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/checkManagement/statisticalStatement/index"
                ),
              name: "统计报表",
              meta: {
                title: "统计报表",
                roles: ["pzkz_pzkz_jc_tongjibaobiao"],
              },
              children: [
                {
                  path: "checkProblem",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityControl/checkManagement/statisticalStatement/checkProblem"
                    ),
                  name: "检查问题统计",
                  meta: {
                    title: "检查问题统计",
                    roles: ["pzkz_pzkz_jc_jianchawentitongji"],
                  },
                  children: [],
                },
                {
                  path: "rectificationCompleted",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityControl/checkManagement/statisticalStatement/rectificationCompleted"
                    ),
                  name: "整改完成统计",
                  meta: {
                    title: "整改完成统计",
                    roles: ["pzkz_pzkz_jc_zhenggaiwanchengtongji"],
                  },
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "questionSeekingManagement",
          component: () =>
            import(
              "@/views/qualityControl/qualityControl/questionSeekingManagement/index"
            ),
          name: "问题征询管理",
          meta: {
            title: "问题征询管理",
            roles: ["pzkz_pzkz_wentizhengxunguanli"],
          },
          children: [
            {
              path: "plannedArrangement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/plannedArrangement"
                ),
              name: "任务列表",
              meta: {
                title: "任务列表",
                roles: ["pzkz_pzkz_zx_jihualiebiao"],
              },
              children: [],
            },
            {
              path: "taskManagement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/taskManagement"
                ),
              name: "任务执行",
              meta: {
                title: "任务执行",
                roles: ["pzkz_pzkz_zx_renwuguanli"],
              },
              children: [],
            },
            {
              path: "taskSupervision",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/taskSupervision"
                ),
              name: "任务管理",
              meta: {
                title: "任务管理",
                roles: ["pzkz_pzkz_zx_renwujianguan"],
              },
              children: [],
            },
            {
              path: "collationClassification",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/collationClassification"
                ),
              name: "整理分类",
              meta: {
                title: "整理分类",
                roles: ["pzkz_pzkz_zx_zhenglifenlei"],
              },
              children: [],
            },
            {
              path: "workItemSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/workItemSetup"
                ),
              name: "整改执行",
              meta: {
                title: "整改执行",
                roles: ["pzkz_pzkz_zx_zhenggaizhixing"],
              },
              children: [],
            },
            {
              path: "workScheduleSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/rectificationSupervision"
                ),
              name: "整改监管",
              meta: {
                title: "整改监管",
                roles: ["pzkz_pzkz_zx_zhenggaijianguan"],
              },
              children: [],
            },
            {
              path: "statisticalStatement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityControl/questionSeekingManagement/statisticalStatement/index"
                ),
              name: "统计报表",
              meta: {
                title: "统计报表",
                roles: ["pzkz_pzkz_zx_tongjibaobiao"],
              },
              children: [
                {
                  path: "consultProblem",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityControl/questionSeekingManagement/statisticalStatement/consultProblem"
                    ),
                  name: "征询问题统计",
                  meta: {
                    title: "征询问题统计",
                    roles: ["pzkz_pzkz_zx_wentizhengxuntongji"],
                  },
                  children: [],
                },
                {
                  path: "rectificationCompleted",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityControl/questionSeekingManagement/statisticalStatement/rectificationCompleted"
                    ),
                  name: "整改完成统计",
                  meta: {
                    title: "整改完成统计",
                    roles: ["pzkz_pzkz_zx_zhenggaiwanchengtongji"],
                  },
                  children: [],
                },
                {
                  path: "consultationResult",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityControl/questionSeekingManagement/statisticalStatement/consultationResult"
                    ),
                  name: "征询结果分类统计",
                  meta: {
                    title: "征询结果分类统计",
                    roles: ["pzkz_pzkz_zx_zhengxunjieguofenleitongji"],
                  },
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "qualityCheck",
      component: () => import("@/views/qualityControl/qualityCheck/index"),
      name: "品质核查",
      meta: {
        title: "品质核查",
        roles: ["pzkz_pinzhihecha"],
      },
      children: [
        {
          path: "checkManagement",
          component: () =>
            import("@/views/qualityControl/qualityCheck/checkManagement/index"),
          name: "检查管理",
          meta: {
            title: "检查管理",
            roles: ["pzkz_pzhc_jianchaguanli"],
          },
          children: [
            {
              path: "plannedArrangement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/plannedArrangement"
                ),
              name: "任务列表",
              meta: {
                title: "任务列表",
                roles: ["pzkz_pzhc_jc_jihualiebiao"],
              },
              children: [],
            },
            {
              path: "taskManagement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/taskManagement"
                ),
              name: "任务执行",
              meta: {
                title: "任务执行",
                roles: ["pzkz_pzhc_jc_renwuguanli"],
              },
              children: [],
            },
          
            {
              path: "workItemSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/workItemSetup"
                ),
              name: "整改执行",
              meta: {
                title: "整改执行",
                roles: ["pzkz_pzhc_jc_zhenggaizhixing"],
              },
              children: [],
            },
            {
              path: "workScheduleSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/rectificationSupervision"
                ),
              name: "整改监管",
              meta: {
                title: "整改监管",
                roles: ["pzkz_pzhc_jc_zhenggaijianguan"],
              },
              children: [],
            },
            {
              path: "taskCc",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/taskCc"
                ),
              name: "任务抄送",
              meta: {
                title: "任务抄送",
                roles: ["pzkz_pzhc_jc_renwuchaosong"],
              },
              children: [],
            },
            {
              path: "taskSupervision",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/taskSupervision"
                ),
              name: "任务管理",
              meta: {
                title: "任务管理",
                roles: ["pzkz_pzhc_jc_renwujianguan"],
              },
              children: [],
            },
            {
              path: "statisticalStatement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/checkManagement/statisticalStatement/index"
                ),
              name: "统计报表",
              meta: {
                title: "统计报表",
                roles: ["pzkz_pzhc_jc_tongjibaobiao"],
              },
              children: [
                {
                  path: "checkProblem",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/checkManagement/statisticalStatement/checkProblem"
                    ),
                  name: "检查问题统计",
                  meta: {
                    title: "检查问题统计",
                    roles: ["pzkz_pzhc_jc_jianchawentitongji"],
                  },
                  children: [],
                },
                {
                  path: "rectificationCompleted",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/checkManagement/statisticalStatement/rectificationCompleted"
                    ),
                  name: "整改完成统计",
                  meta: {
                    title: "整改完成统计",
                    roles: ["pzkz_pzhc_jc_zhenggaiwanchengtongji"],
                  },
                  children: [],
                },
                {
                  path: "deductionStatistics",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/checkManagement/statisticalStatement/deductionStatistics"
                    ),
                  name: "扣款统计",
                  meta: {
                    title: "扣款统计",
                    roles: ["pzkz_pzhc_jc_koukuantongji"],
                  },
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "questionSeekingManagement",
          component: () =>
            import(
              "@/views/qualityControl/qualityCheck/questionSeekingManagement/index"
            ),
          name: "问题征询管理",
          meta: {
            title: "问题征询管理",
            roles: ["pzkz_pzhc_wentizhengxunguanli"],
          },
          children: [
            {
              path: "plannedArrangement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/plannedArrangement"
                ),
              name: "任务列表",
              meta: {
                title: "任务列表",
                roles: ["pzkz_pzhc_zx_jihualiebiao"],
              },
              children: [],
            },
            {
              path: "wtzxtaskManagement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/taskManagement"
                ),
              name: "任务执行",
              meta: {
                title: "任务执行",
                roles: ["pzkz_pzhc_zx_renwuguanli"],
              },
              children: [],
            },
            
            {
              path: "collationClassification",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/collationClassification"
                ),
              name: "整理分类",
              meta: {
                title: "整理分类",
                roles: ["pzkz_pzhc_zx_zhenglifenlei"],
              },
              children: [],
            },
            {
              path: "questionRectificationPlan",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/rectificationPlan/index.vue"
                ),
              name: "整改计划",
              meta: {
                title: "整改计划",
                roles: ["pzkz_pzhc_zx_zhenggaijihua"],
              },
              children: [],
            },
            {
              path: "questionWorkItemSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/workItemSetup"
                ),
              name: "整改执行",
              meta: {
                title: "整改执行",
                roles: ["pzkz_pzhc_zx_zhenggaizhixing"],
              },
              children: [],
            },
            {
              path: "wtzxworkScheduleSetup",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/rectificationSupervision"
                ),
              name: "整改监管",
              meta: {
                title: "整改监管",
                roles: ["pzkz_pzhc_zx_zhenggaijianguan"],
              },
              children: [],
            },
            {
              path: "taskCc",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/taskCc"
                ),
              name: "任务抄送",
              meta: {
                title: "任务抄送",
                roles: ["pzkz_pzhc_zx_renwuchaosong"],
              },
              children: [],
            },
            {
              path: "taskSupervision",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/taskSupervision"
                ),
              name: "任务管理",
              meta: {
                title: "任务管理",
                roles: ["pzkz_pzhc_zx_renwujianguan"],
              },
              children: [],
            },
            {
              path: "statisticalStatement",
              component: () =>
                import(
                  "@/views/qualityControl/qualityCheck/questionSeekingManagement/statisticalStatement/index"
                ),
              name: "统计报表",
              meta: {
                title: "统计报表",
                roles: ["pzkz_pzhc_zx_tongjibaobiao1"],
              },
              children: [
                {
                  path: "consultProblem",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/questionSeekingManagement/statisticalStatement/consultProblem"
                    ),
                  name: "征询问题统计",
                  meta: {
                    title: "征询问题统计",
                    roles: ["pzkz_pzhc_zx_wentizhengxuntongji"],
                  },
                  children: [],
                },
                {
                  path: "rectificationCompleted",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/questionSeekingManagement/statisticalStatement/rectificationCompleted"
                    ),
                  name: "整改完成统计",
                  meta: {
                    title: "整改完成统计",
                    roles: ["pzkz_pzhc_zx_zhenggaiwanchengtongji"],
                  },
                  children: [],
                },
                {
                  path: "consultationResult",
                  component: () =>
                    import(
                      "@/views/qualityControl/qualityCheck/questionSeekingManagement/statisticalStatement/consultationResult"
                    ),
                  name: "征询结果分类统计",
                  meta: {
                    title: "征询结果分类统计",
                    roles: ["pzkz_pzhc_zx_zhengxunjieguofenleitongji"],
                  },
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "qualityRectification",
      component: () =>
        import("@/views/qualityControl/qualityRectification/index"),
      meta: {
        title: "品质整改",
        roles: ["pzkz_pinzhizhenggai"],
      },
      alwaysShow: true,
      children: [
        {
          path: "workItemSetup",
          component: () =>
            import(
              "@/views/qualityControl/qualityRectification/rectificationExecution"
            ),
          name: "整改执行",
          meta: {
            title: "整改执行",
            roles: ["pzkz_zhenggaizhixing"],
          },
          children: [],
        },
        {
          path: "workScheduleSetup",
          component: () =>
            import(
              "@/views/qualityControl/qualityRectification/rectificationSupervision"
            ),
          name: "整改监管",
          meta: {
            title: "整改监管",
            roles: ["pzkz_zhenggaijianguan"],
          },
          children: [],
        },
        // {
        //   path: "rectificationStatistics",
        //   component: () =>
        //     import("@/views/qualityControl/qualityRectification/rectificationStatistics"),
        //   name: "整改统计",
        //   meta: {
        //     title: "整改统计",
        //     roles: ["pzkz_zhenggaitongji"]
        //   },
        //   children: []
        // },
      ],
    },

    {
      path: "customerRectification",
      component: () =>
        import("@/views/qualityControl/customerRectification/index"),

      meta: {
        title: "客户检查整改",
        roles: ["pzkz_kehujianchazhenggai"],
      },
      alwaysShow: true,
      children: [
        {
          path: "rectificationHandling",
          component: () =>
            import(
              "@/views/qualityControl/customerRectification/rectificationHandling"
            ),
          name: "整改处理",
          meta: {
            title: "整改处理",
            roles: ["pzkz_khjczg_zhenggaichuli"],
          },
          children: [],
        },
        {
          path: "rectificationSupervision",
          component: () =>
            import(
              "@/views/qualityControl/customerRectification/rectificationSupervision"
            ),
          name: "整改管理",
          meta: {
            title: "整改管理",
            roles: ["pzkz_khjczg_zhenggaijianguan"],
          },
          children: [],
        },
        {
          path: "qualityAdministrator",
          component: () =>
            import("@/views/qualityControl/qualityAdministrator"),
          name: "项目负责人维护",
          meta: {
            title: "项目负责人维护",
            roles: ["pzkz_xiangmufuzerenweihu"],
          },
          children: [],
        },
      ],
    },
   
    {
      path: "satisfactionRating",
      component: () =>
        import("@/views/qualityControl/satisfactionRating/index"),
      meta: {
        title: "满意度评分",
        roles: ["pzkz_manyidupingfen"],
      },
      alwaysShow: true,
      children: [
        {
          path: "customerManagement",
          component: () =>
            import(
              "@/views/qualityControl/satisfactionRating/customerManagement"
            ),
          name: "客户管理",
          meta: {
            title: "客户管理",
            roles: ["pzkz_kehuguanli"],
          },
          children: [],
        },
        {
          path: "quScoreThanks",
          component: () =>
            import("@/views/qualityControl/satisfactionRating/quScoreThanks"),
          name: "感谢语维护",
          meta: {
            title: "感谢语维护",
            roles: ["pzkz_ganxieyuweihu"],
          },
          children: [],
        },
        {
          path: "scoringDimension",
          component: () =>
            import(
              "@/views/qualityControl/satisfactionRating/scoringDimension"
            ),
          name: "评分维度管理",
          meta: {
            title: "评分维度管理",
            roles: ["pzkz_pingfenweiduguanli"],
          },
          children: [],
        },
        {
          path: "scoringPlan",
          component: () =>
            import("@/views/qualityControl/satisfactionRating/scoringPlan"),
          name: "评分计划设置",
          meta: {
            title: "评分计划设置",
            roles: ["pzkz_pingfenjihuashezhi"],
          },
          children: [],
        },
        {
          path: "scoringManagement",
          component: () =>
            import(
              "@/views/qualityControl/satisfactionRating/scoringManagement"
            ),
          name: "评分管理",
          meta: {
            title: "评分管理",
            roles: ["pzkz_pingfenguanli"],
          },
          children: [],
        },
        {
          path: "scoringFeedbackRectification",
          component: () =>
            import(
              "@/views/qualityControl/satisfactionRating/scoringFeedbackRectification"
            ),
          name: "评分反馈整改",
          meta: {
            title: "评分反馈整改",
            roles: ["pzkz_pingfenfankuizhenggai"],
          },
          children: [],
        },
        {
          path: "scoringFeedbackCollation",
          component: () =>
            import(
              "@/views/qualityControl/satisfactionRating/scoringFeedbackCollation"
            ),
          name: "评分反馈整理",
          meta: {
            title: "评分反馈整理",
            roles: ["pzkz_pingfenfankuizhengli"],
          },
          children: [],
        },
      ],
    },

    {
      path: "statisticalAnalysis",
      component: () =>
        import("@/views/qualityControl/satisfactionRating/index"),
      meta: {
        title: "统计分析",
        roles: ["pzkz_manyidupingfen"],
      },
      alwaysShow: true,
      children: [
        {
          path: "checkMan",
          component: () =>
            import(
              "@/views/qualityControl/statisticalAnalysis/checkMan/index"
            ),
          name: "检查管理",
          meta: {
            title: "检查管理",
            roles: ["pzkz_manyidupingfen"],
          },
          children: [],
        },
        {
          path: "questionInquiry",
          component: () =>
            import(
              "@/views/qualityControl/statisticalAnalysis/questionInquiry/index"
            ),
          name: "问题征询",
          meta: {
            title: "问题征询",
            roles: ["pzkz_manyidupingfen"],
          },
          children: [],
        },
        {
          path: "satisfiedScore",
          component: () =>
            import(
              "@/views/qualityControl/statisticalAnalysis/satisfiedScore/index"
            ),
          name: "满意度评分",
          meta: {
            title: "满意度评分",
            roles: ["pzkz_manyidupingfen"],
          },
          children: [],
        },
      ],
    },
  ],
};

export default qualityControlRouter;
